module.exports = __webpack_public_path__ + "static/img/荣耀-YOYO.d4eec140.png";